import { Edit, View } from 'assets/Icons'
import { Tooltip } from 'components/Overlay'
import Pagination from 'components/Pagination'
import Table from 'components/Table/index'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import services from 'services/index'
import { Head, Header } from './components'
import DeleteStudent from './components/DeleteStudent'
import { deafaultFilter } from './constants'

const Student = () => {
	const navigate = useNavigate()
	const role = useSelector(state => state?.user?.user?.user_type)
	const [loading, setLoading] = useState(false)
	const [data, setData] = useState([])

	const [totalItemsCount, setTotalItemsCount] = useState(0)
	const [filter, setFilter] = useState(deafaultFilter)
	const { page, page_size } = filter

	const getStudents = filter => {
		const options = {
			filter,
			onEnd: () => setLoading(false),
			onError: () => setData([]),
			onStart: () => setLoading(true),
			onSuccess: response => {
				setTotalItemsCount(response?.data?.count)
				setData(response?.data?.results)
			},
		}
		services.students.getStudents(options)
	}
	useEffect(() => {
		getStudents(filter)
	}, [filter])
	const onChangePage = value => {
		const newFilter = { ...filter, ...value }
		setFilter(newFilter)
	}

	const headers = useMemo(() => {
		const headers = [
			{
				key: 'order',
				label: <div className='min-w-[20px] text-center sm:text-start'>№</div>,
				getContent: ({ data, key, index }) => {
					const order = index + 1 + (page - 1) * page_size
					return <div className='text-center sm:text-start'>{order}</div>
				},
			},
			{
				key: 'first_name',
				label: 'Ism',
				getContent: ({ data, key, index }) => {
					const name = data?.first_name
					return <div className='!text-start'>{name}</div>
				},
			},
			{
				key: 'last_name',
				label: 'Familiya',
				getContent: ({ data, key, index }) => {
					const name = data?.last_name
					return <div className='text-start'>{name}</div>
				},
			},
			{
				key: 'student_class',
				label: 'Sinf',
				getContent: ({ data, key, index }) => {
					const student_class = data?.student_class
					return (
						<div className='text-start'>
							{student_class ? student_class : '-'}
						</div>
					)
				},
			},
			{
				key: 'first_name',
				label: 'Guruhlari',
				getContent: ({ data, key, index }) => {
					const groups = data?.groups
					return groups.map((item, index) => <div className='text-start' key={item.id}>{item.name}</div>)
				},
			},
			{
				key: 'phone_number',
				label: 'Otasining telefon raqami',
				getContent: ({ data, key, index }) => {
					const phone = data?.phone_number || '-'
					return <div className='text-start'>{phone}</div>
				},
			},
			{
				key: 'phone_number',
				label: 'Onasining telefon raqami',
				getContent: ({ data, key, index }) => {
					const phone = data?.phone_number2 || '-'
					return <div className='text-start'>{phone}</div>
				},
			},
			{
				key: 'actions',
				label: 'Amallar',
				getContent: ({ data, key, index }) => {
					const id = data?.id
					return (
						<div className='flex justify-center sm:justify-start items-center'>
							<Tooltip
								title={role === 'admin' ? 'Tahrirlash' : "Ko'rish"}
								distance={6}
							>
								<button
									className='edit-icon'
									onClick={() =>
										navigate(`/account/students/update/${id}`, {
											state: { updateData: data },
										})
									}
								>
									{role === 'admin' ? <Edit /> : <View />}
								</button>
							</Tooltip>
							{role === 'admin' ? (
								<DeleteStudent
									id={id}
									filter={filter}
									getStudents={getStudents}
								/>
							) : (
								<></>
							)}
						</div>
					)
				},
			},
		]
		return headers
	}, [filter, navigate, page, page_size, role])
	return (
		<div className='sm:p-6 p-3'>
			<Head />
			<Header filter={filter} setFilter={setFilter} />
			<Table isLoading={loading} data={data} headers={headers} />
			<div className='pt-[20px]'>
				<Pagination
					isDisabled={loading}
					onChange={onChangePage}
					page={page}
					page_size={page_size}
					totalItemsCount={totalItemsCount}
				/>
			</div>
		</div>
	)
}

export default Student
